import { BsHeader } from './BsHeader';
export default BsHeader;
